import { createSlice } from '@reduxjs/toolkit';

const initialState = '';

const searchResultsPageAliasSlice = createSlice({
	name: 'searchResultsPageAlias',
	initialState,
	reducers: {
		setSearchResultsPageAlias: (state, action) => {
			return typeof action.payload === 'string' ? action.payload : state;
		}
	}
});

export const { setSearchResultsPageAlias } =
	searchResultsPageAliasSlice.actions;
export default searchResultsPageAliasSlice.reducer;
